import { useState, useEffect } from "react";
import Style from "./VariationPlansDetailStyle";
import Spinner from "../../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../../shared/Bootstrap/TwoButtonsModal";
import { AxiosRequestConfig } from "axios";
import api from "../../../services/api";
import PageTitle from "../../../components/PageTitle";
import { GetFileFromURL, StringToBool } from "../../../utils";
import { InputImage } from "../../../components/InputImage/InputImage";
import InfoModal from "../../../shared/Bootstrap/InfoModal";
import { GenericInputFileWithPreview } from "../../../components/GenericInputFileWithPreview/GenericInputFileWithPreview";

export default function VariationPlans(props) {

  const [name, setName] = useState("");
  const [sceneName, setSceneName] = useState("");
  const [hasZoom, setHasZoom] = useState("" as any);
  const [selectedImage, setSelectedImage] = useState({} as File);
  const [selectedTechnicalPlan, setSelectedTechnicalPlan] = useState({} as File);
  const [imageUrl, setImageUrl] = useState("");
  const [selectedDetailedPlan, setSelectedDetailedPlan] = useState({} as File);

  const [selectedAssetBundle, setSelectedAssetBundle] = useState({} as File);
  const [assetBundleUrl, setAssetBundleUrl] = useState("");
  const [deleteAssetBundle, setDeleteAssetBundle] = useState(false);

  const [technicalPlanUrl, setTechnicalPlanUrl] = useState("");
  const [detailedPlanUrl, setDetailedPlanUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [deleteImage, setDeleteImage] = useState(false);
  const [deleteTechnicalPlan, setDeleteTechnicalPlan] = useState(false);
  const [deleteDetailedPlan, setDeleteDetailedPlan] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const variationId = props.match.params.variationId;
  const planId = props.match.params.planId
  const creatingNew = variationId <= 0;

  useEffect(() => {
    if (!creatingNew)
      LoadVariation(variationId);

  }, []);

  async function LoadVariation(variationId) {
    try {
      const result = await api.get(`/plans/variations/${variationId}`);
      if (result.data.success) {
        let variation = result.data.variation;
        setName(variation.name)
        setSceneName(variation.sceneName);
        setHasZoom(StringToBool(variation.hasZoom));
        setImageUrl(variation.image);
        setTechnicalPlanUrl(variation.technicalPlanImage);
        setDetailedPlanUrl(variation.detailedPlanImage);
        setAssetBundleUrl(variation.assetBundle);

        setLoading(false);
      }
    } catch (error: any) {
      setMessageError(error.response?.data?.message || "Não foi possível carregar a variação.");
    } finally {
      setLoading(false);
    }
  }

  async function OnSubmit() {
    try {
      setLoading(true);
      onClosePopup();
      const options: AxiosRequestConfig = {};
      const formData = new FormData();
      if (selectedImage.name && !deleteImage) {
        formData.append("image", selectedImage, selectedImage.name);
      }
      if (selectedTechnicalPlan.name && !deleteTechnicalPlan) {
        formData.append("technicalPlanImage", selectedTechnicalPlan, selectedTechnicalPlan.name);
      }
      if (selectedDetailedPlan.name && !deleteDetailedPlan) {
        formData.append("detailedPlanImage", selectedDetailedPlan, selectedDetailedPlan.name);
      }
      if (selectedAssetBundle.name && !deleteAssetBundle) {
        formData.append("assetBundle", selectedAssetBundle, selectedAssetBundle.name);
      }


      if (!creatingNew) {
        formData.append("deleteImage", deleteImage.toString());
        formData.append("deleteTechnicalPlan", deleteTechnicalPlan.toString());
        formData.append("deleteDetailedPlan", deleteDetailedPlan.toString());
        formData.append("deleteAssetBundle", deleteAssetBundle.toString());

      }
      formData.append("name", name);
      formData.append("sceneName", sceneName);
      formData.append("hasZoom", hasZoom);

      await (creatingNew ?
        api.post(`/plans/${planId}/variations`, formData, options) :
        api.put(`/plans/variations/${variationId}`, formData, options));
      if (creatingNew) {
        props.history.goBack();
      }
      else {
        setShowSuccessPopup(true);
        setSelectedAssetBundle({} as File);
        setDeleteAssetBundle(false);
        LoadVariation(variationId);
      }
    }
    catch (error: any) {
      setMessageError(error?.response?.data?.message)
    }
    finally {
      setLoading(false);
      onClosePopup();
    }
  }

  function onOpenPopUp() {
    setShowPopup(true);
  }

  function onClosePopup() {
    setShowPopup(false);
  }

  function onChangeImage(event) {
    setSelectedImage(event.target.files[0]);
    setDeleteImage(false)
  };
  function OnChangeTechnicalPlan(e) {
    setSelectedTechnicalPlan(e.target.files[0]);
    setDeleteTechnicalPlan(false)
  }
  function OnChangeDetailedPlan(e) {
    setSelectedDetailedPlan(e.target.files[0]);
    setDeleteDetailedPlan(false)
  }

  function OnChangeAssetBundle(event) {
    setSelectedAssetBundle(event.target.files[0]);
    setDeleteAssetBundle(false);
  }
  function OnRemoveAssetBundle() {
    //Se ja tiver um asset bundle, remover, se não tiver e tiver remoto, marcar para remover remoto
    //No momento não é deletado remoto pois não havia necessidade
    if (selectedAssetBundle?.name) {
      setSelectedAssetBundle({} as File);
      return;
    }
    else if (assetBundleUrl) {
      setDeleteAssetBundle(true);
    }
  }



  function GetImageUrl(): string {
    return GetFileFromURL(imageUrl, `${process.env.REACT_APP_BASE_URL}/plans/variations/${variationId}/image`);
  }
  function GetTechnicalImageUrl(): string {
    return GetFileFromURL(technicalPlanUrl, `${process.env.REACT_APP_BASE_URL}/plans/variations/${variationId}/technicalPlanImage`);
  }
  function GetDetailedImageUrl(): string {
    return GetFileFromURL(detailedPlanUrl, `${process.env.REACT_APP_BASE_URL}/plans/variations/${variationId}/detailedPlanImage`);
  }
  function ShowSuccessPopup() {
    return (
      <InfoModal
        show={showSuccessPopup}
        onHide={() => setShowSuccessPopup(false)}
        loading={false}
        title={creatingNew ? "Variação de planta salva com sucesso!" : "Variação de planta editada com sucesso!"}
        body="Suas edições foram salvas com sucesso!"
        primaryText="OK"
        primaryOnClick={() => setShowSuccessPopup(false)}
        primaryDisabled={false}
      />
    )
  }
  return (
    <Style>
      {ShowSuccessPopup()}
      <PageTitle title="Detalhes da Variação da Planta" />
      <TwoButtonsModal
        show={showPopup}
        onHide={onClosePopup}
        loading={loading}
        title={creatingNew ? "Cadastro de variação" : "Edição de variação"}
        body={"Você tem certeza que deseja " + (creatingNew ? " Cadastrar esta variação?" : "editar esta variação?")}
        secondaryText="Fechar"
        secondaryOnClick={onClosePopup}
        secondaryDisabled={loading}
        primaryText="Confirmar"
        primaryOnClick={() => OnSubmit()}
        primaryDisabled={loading}
      />
      <div className="variation">
        <div>
          <button onClick={() => props.history.goBack()} className=" btn-secondary">Voltar</button>
        </div>
        <Spinner spinning={loading} />
        {messageError && <p className="alert alert-error">Erro: {messageError}</p>}
        <main>
          <div className="panel">
            <form className="main-form" onSubmit={(e) => { e.preventDefault() }}>
              <h2>{creatingNew ? "Criação" : "Edição"} de variação</h2>
              <div>
                <label>Nome:</label>
                <input

                  disabled={!creatingNew}
                  defaultValue={name}
                  onChange={e => setName(e.target.value)}
                />
              </div>
              <div>
                <label>Nome da cena:</label>
                <input

                  disabled={loading}
                  defaultValue={sceneName}
                  onChange={e => setSceneName(e.target.value)}
                />
              </div>
              <div>
                <label>Zoom</label>
                <div className="checkbox">
                  <input
                    type="checkbox"

                    disabled={loading}
                    value={hasZoom}
                    checked={hasZoom}
                    onChange={e => setHasZoom(e.target.checked)}
                  />
                </div>
              </div>
              <div>
                <label>Imagem:</label>
                <InputImage
                  id="image"
                  name="image"
                  label=""
                  alt="Imagem"
                  acceptedMimeTypes="image/png, image/jpeg"
                  imageUrl={GetImageUrl()}
                  OnChange={onChangeImage}
                  OnRemove={() => setDeleteImage(true)}
                  image={selectedImage}
                />
              </div>
              <div>
                <label>Planta Técnica:</label>
                <InputImage
                  id="technicalPlan"
                  name="technicalPlan"
                  label=""
                  alt="Imagem da Planta Técnica"
                  acceptedMimeTypes="image/png, image/jpeg"
                  imageUrl={GetTechnicalImageUrl()}
                  OnChange={OnChangeTechnicalPlan}
                  OnRemove={() => setDeleteTechnicalPlan(true)}
                  image={selectedTechnicalPlan}
                />
              </div>
              <div>
                <label>Planta Detalhada:</label>
                <InputImage
                  id="detailedPlan"
                  name="detailedPlan"
                  label=""
                  alt="Imagem da Planta Técnica"
                  acceptedMimeTypes="image/png, image/jpeg"
                  imageUrl={GetDetailedImageUrl()}
                  OnChange={OnChangeDetailedPlan}
                  OnRemove={() => setDeleteDetailedPlan(true)}
                  image={selectedDetailedPlan}
                />
              </div>
              <div>
                <label>Asset Bundle:</label>
                <GenericInputFileWithPreview
                  id="assetBundle"
                  name="assetBundle"
                  label="Arquivo"
                  alt="AssetBundle da cena da planta"
                  acceptedMimeTypes="*/*"
                  fileUrl={assetBundleUrl}
                  file={selectedAssetBundle}
                  deleted={deleteAssetBundle}
                  OnChange={OnChangeAssetBundle}
                  OnRemove={OnRemoveAssetBundle}
                />
              </div>


              <button
                className="btn btn-success btn-lg mt-4"
                type="button"
                disabled={name === ""}
                onClick={e => { e.preventDefault(); onOpenPopUp(); }}>
                {creatingNew ? "Cadastrar" : "Editar"}
              </button>
            </form>
          </div>
        </main>
      </div>
    </Style>
  )
}
